import {defineSlotRecipe} from '@chakra-ui/react3'

export const phoneCountrySelectRecipe = defineSlotRecipe({
    slots: [
        'root',
        'control',
        'trigger',
        'indicator',
        'content',
        'item',
        'countryFlag',
        'countryDialCode',
        'itemText'
    ],
    base: {
        root: {
            display: 'block',
            position: 'static',
            width: 'auto'
        },
        control: {
            position: 'static'
        },
        trigger: {
            alignItems: 'center',
            display: 'flex',
            gap: 'spacing-8',
            height: 'var(--phone-input-height)',
            minHeight: 'var(--phone-input-height)',
            paddingInline: 'spacing-8',
            pointerEvents: 'auto',
            width: 'auto',
            focusVisibleRing: 'inside',
            focusRingColor: 'blue.focusRing',
            focusRingOffset: '0',
            focusRingWidth: '{spacing.spacing-2}'
        },
        indicator: {
            backgroundColor: 'icons.primary',
            clipPath: 'polygon(0 0, 100% 0, 50% 100%)',
            flexShrink: 0,
            height: 'spacing-8',
            marginInlineStart: 'spacing-4',
            transitionDuration: 'moderate',
            transitionProperty: 'transform',
            width: 'spacing-12',
            _open: {
                transform: 'rotate(180deg)'
            }
        },
        content: {
            animationDuration: 'moderate',
            backgroundColor: 'background.actions.tertiary',
            maxHeight:
                'calc({spacing.spacing-160} * 2 + {spacing.spacing-128} + {spacing.spacing-16})',
            overflowY: 'auto',
            paddingBlock: 'spacing-8',
            transformOrigin: 'top',
            width: '100%',
            _open: {
                animationStyle: 'scale-fade-in'
            },
            _closed: {
                animationDuration: 'faster',
                animationStyle: 'scale-fade-out'
            },
            '&::-webkit-scrollbar': {
                width: 'spacing-18'
            },
            '&::-webkit-scrollbar-thumb': {
                backgroundClip: 'content-box',
                backgroundColor: 'primary.base.black',
                borderInline: '{spacing.spacing-8} solid transparent',
                borderTop: '{spacing.spacing-8} solid transparent'
            },
            '&::-webkit-scrollbar-track': {
                backgroundClip: 'content-box',
                backgroundColor: 'border.medium',
                borderInline: '{spacing.spacing-8} solid transparent',
                borderTop: '{spacing.spacing-8} solid transparent'
            }
        },
        item: {
            alignItems: 'center',
            cursor: 'pointer',
            display: 'flex',
            gap: 'spacing-8',
            justifyContent: 'flex-start',
            paddingBlock: 'spacing-6',
            paddingInline: 'spacing-8',
            width: '100%',
            _selected: {
                backgroundColor: 'background.actions.tertiary-active'
            },
            _highlighted: {
                backgroundColor: 'background.actions.tertiary-active',
                outlineColor: 'blue.focusRing',
                outlineOffset: 'calc(-1 * {spacing.spacing-2})',
                outlineStyle: 'solid',
                outlineWidth: '{spacing.spacing-2}'
            },
            _hover: {
                backgroundColor: 'background.actions.tertiary-hover'
            }
        },
        countryFlag: {
            flexShrink: 0,
            height: 'spacing-24',
            width: 'spacing-24',
            '& > img': {
                display: 'block',
                height: '100%',
                width: '100%'
            }
        },
        countryDialCode: {
            flexShrink: 0
        },
        itemText: {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        }
    }
})

export default {
    inputGroup: {
        '--phone-input-height': '3.6875rem',
        '--gap-selector-input': '0.75rem',
        alignItems: 'center',
        borderBottom: '0.125rem solid',
        borderColor: 'stokkeCore.black',
        backgroundColor: 'stokkeCore.white',
        display: 'grid',
        columnGap: 'var(--gap-selector-input)',
        gridTemplateColumns: 'max-content minmax(0, 1fr)',
        position: 'relative',
        _invalid: {
            borderColor: 'stokkeFunctional.alertRed'
        },
        // Field does not expose props for styling the left-element wrapper.
        '& > .chakra-input__left-element': {
            gridColumn: 1,
            position: 'static'
        },
        '& > .chakra-input': {
            // This selector outranks the flushed input variant's bottom border.
            borderBottomWidth: 0
        }
    },
    input: {
        height: 'var(--phone-input-height)',
        paddingInlineEnd: 12,
        gridColumn: 2,
        minWidth: 0,
        paddingInlineStart: 2,
        _focus: {
            borderWidth: 0
        },
        _focusVisible: {
            borderWidth: 0
        },
        _invalid: {
            borderWidth: 0
        }
    }
}
